import React from "react";
import { MDBCard, MDBCardBody, MDBCardTitle } from "mdb-react-ui-kit";
import { LoginForm } from "../util/token";
import useLocale from "../util/i18n";
import { Helmet } from "react-helmet-async";
import { useCrumbs } from "../component/breadcrumbs";

export default function Login() {
    const { 0: __ } = useLocale();
    const {0: setCrumbs} = useCrumbs();
    React.useEffect(() => {
        setCrumbs([__('Account Login')]);
    }, [__]);
    return (
        <div className="login-panel" style={{ backgroundImage: "url(/login-bg.jpg)" }}>
            <Helmet prioritizeSeoTags>
                <title>{__('Account Login')}</title>
            </Helmet>
            <MDBCard>
                <MDBCardBody>
                    <MDBCardTitle className="mb-4 text-center">{__('Account Login')}</MDBCardTitle>
                    <LoginForm />
                </MDBCardBody>
            </MDBCard>
            <img className="logo" src="/logo-w.png" width="243" height="41" alt="" />
        </div>
    );
};
